import { makeStyles } from '@material-ui/core';
import { tcsmColors } from '../../theme-constants/colors';



export const dividerSectionStyles = makeStyles((theme) => ({
    dividerSectionWrapper: {
        '& > [class*="dividerSection"]': {
            '&:last-child': {
                borderBottom: 'none',
            },

        },
    },
    dividerSection: {
        paddingBottom: '4rem',
        marginBottom: '4rem',
        borderBottom: '1px solid #E1E1E1 ',
        [theme.breakpoints.down('md')]: {
            marginBottom: '3rem',
            paddingBottom: '3rem',
        },
        [theme.breakpoints.down('sm')]: {
            marginBottom: '2rem',
            paddingBottom: '2rem',
        },
        '&.dashed-border': {
            borderBottom: '1px dashed #E1E1E1 ',
        },
    },

    topDivider: {
        paddingTop: '4rem',
        marginBottom: '4rem',
        borderTop: '1px solid #E1E1E1 ',
        [theme.breakpoints.down('md')]: {
            marginBottom: '3rem',
            paddingTop: '3rem',
        },
        [theme.breakpoints.down('sm')]: {
            marginBottom: '2rem',
            paddingTop: '2rem',
        },

    },
    grayBackground: {
        padding: theme.spacing(1.25),
        backgroundColor: tcsmColors.greySeven,
    },
    genericSection: {
        paddingBottom: '4rem',
        [theme.breakpoints.down('md')]: {
            paddingBottom: '3rem',
        },
        [theme.breakpoints.down('sm')]: {
            paddingBottom: '2rem',
        },

    },
    dividerHeader: {

        display: 'flex',
        alignItems: 'center',
        [theme.breakpoints.down('sm')]: {
            justifyContent: 'space-between',
        },
        '& .divider-header': {
            '&-inner': {
                display: 'flex',
                paddingRight: theme.spacing(1),

                '& > svg': {
                    marginRight: theme.spacing(.5),
                },
            },
        },
    },
    disableSection: {
        position: 'relative',
        '&:before': {
            content: '" "',
            backgroundColor: 'rgba(255,255, 255, .5)',
            position: 'absolute',
            top: '0',
            bottom: '0',
            width: '100%',
            cursor: 'not-allowed',
            zIndex: '1',
        },
        
    },
    dividerSectionContent: {

        '& .divider-section': {
            '&-item': {
                '&-header': {
                    marginBottom: theme.spacing(1),
                },
                '& + .divider-section-item': {
                    marginTop: theme.spacing(1.5),
                },
            },
        },
        '& .midyear-selection-section': {
            '& + .midyear-selection-section': {
                marginTop: '4rem',
                [theme.breakpoints.down('md')]: {
                    marginTop: '3rem',
                },
                [theme.breakpoints.down('sm')]: {
                    marginTop: '2rem',
                },
            },
        },
    },

}));


